// extracted by mini-css-extract-plugin
module.exports = {"list":"LinkList_list__4jLjh","item":"LinkList_item__1EdUC"};